import React from 'react';
import { BoxIcon } from 'lucide-react';
interface ValueCardProps {
  icon: BoxIcon;
  title: string;
  description: string;
}
export function ValueCard({
  icon: Icon,
  title,
  description
}: ValueCardProps) {
  return <div className="group relative bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl hover:from-white hover:to-red-50/30 border border-gray-100/50 hover:border-red-100 shadow-premium hover:shadow-premium-xl transition-all duration-500 text-center h-full overflow-hidden hover-lift" data-id="element-291">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-[0.02] group-hover:opacity-[0.04] transition-opacity duration-500" data-id="element-292">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, currentColor 1px, transparent 0)',
        backgroundSize: '24px 24px'
      }} data-id="element-293"></div>
      </div>

      <div className="relative z-10" data-id="element-294">
        {/* Icon */}
        <div className="mx-auto w-20 h-20 rounded-2xl bg-white shadow-sm flex items-center justify-center text-[#C4161C] mb-6 group-hover:scale-110 group-hover:shadow-red transition-all duration-500 border border-gray-100" data-id="element-295">
          <Icon className="w-10 h-10" strokeWidth={1.5} data-id="element-296" />
        </div>

        <h3 className="text-xl font-bold text-gray-900 mb-4 heading-premium group-hover:text-[#C4161C] transition-colors duration-300" data-id="element-297">
          {title}
        </h3>

        <p className="text-gray-600 leading-relaxed text-sm" data-id="element-298">{description}</p>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-16 h-16 bg-gradient-to-br from-[#C4161C]/5 to-transparent rounded-br-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-299"></div>
      <div className="absolute bottom-0 right-0 w-16 h-16 bg-gradient-to-tl from-[#C4161C]/5 to-transparent rounded-tl-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-300"></div>
    </div>;
}